import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const TONES = {
  critical: {
    border: "border-red-500/40",
    dot: "bg-red-500",
    badge: "border-red-500/40 bg-red-950/60 text-red-200",
  },
  action: {
    border: "border-amber-400/40",
    dot: "bg-amber-400",
    badge: "border-amber-400/40 bg-amber-950/60 text-amber-200",
  },
  warning: {
    border: "border-yellow-400/40",
    dot: "bg-yellow-400",
    badge: "border-yellow-400/40 bg-yellow-950/60 text-yellow-200",
  },
  neutral: {
    border: "border-stone-100/15",
    dot: "bg-stone-400",
    badge: "border-stone-100/15 bg-zinc-900 text-stone-300",
  },
};

/**
 * Collapsible priority group. Starts collapsed; the entire header row is a
 * single accessible button with aria-expanded and a count badge.
 */
export default function PriorityAccordion({ id, title, count, tone = "neutral", children }) {
  const [open, setOpen] = useState(false);
  const styles = TONES[tone] || TONES.neutral;
  return (
    <div className={`rounded-xl border ${styles.border} bg-zinc-900/60`}>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen((current) => !current)}
        className="flex min-h-12 w-full items-center justify-between gap-3 px-4 py-3 text-left"
        data-testid={`${id}-toggle`}
      >
        <span className="flex min-w-0 items-center gap-3">
          <span aria-hidden="true" className={`h-2.5 w-2.5 shrink-0 rounded-full ${styles.dot}`} />
          <span className="truncate font-semibold text-stone-100">{title}</span>
          <span className={`shrink-0 rounded-full border px-2 py-0.5 text-xs ${styles.badge}`}>{count}</span>
        </span>
        <ChevronDown
          aria-hidden="true"
          className={`h-4 w-4 shrink-0 text-stone-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>
      <div
        id={id}
        className={`grid transition-[grid-template-rows] duration-200 ease-out ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
      >
        <div className="overflow-hidden">
          <div className="space-y-3 border-t border-stone-100/10 px-4 py-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
